import { DocumentNode, Kind, OperationDefinitionNode } from 'graphql';

export const getOperationName = (doc: DocumentNode): string | undefined =>
  doc.definitions
    .filter((d): d is OperationDefinitionNode => d.kind === Kind.OPERATION_DEFINITION)
    .find((d) => !!d.name)?.name!.value;
